import { TrackingData } from '../useTracking';
import { findHeadersLinkByUrlWithoutParams } from './findHeadersLinkByUrlWithoutParams';
import { getPageViewSpecialCategories } from './getPageViewSpecialCategories';
import {
  DATA_TRACKING_SECTION,
  DATA_TRACKING_SUBMENU,
} from './getTrackingAttributes';
import { getTrackingDefaultPayload } from './getTrackingDefaultPayload';

export const getPageViewPayload = (trackingData: TrackingData) => {
  const urlInMHeader = findHeadersLinkByUrlWithoutParams(
    window.location.href,
    trackingData.headersLinks,
  );
  const specialCategories: string[] | undefined =
    getPageViewSpecialCategories();
  const pageCategories: Record<string, string | null | undefined> = {};

  if (specialCategories) {
    specialCategories.forEach((category, index) => {
      pageCategories[`pageCategory${index + 1}`] = category;
    });
  } else {
    pageCategories.pageCategory1 = urlInMHeader
      ?.closest(`[${DATA_TRACKING_SUBMENU}]`)
      ?.getAttribute(DATA_TRACKING_SUBMENU);
    pageCategories.pageCategory2 = urlInMHeader
      ?.closest(`[${DATA_TRACKING_SECTION}]`)
      ?.getAttribute(DATA_TRACKING_SECTION);
  }

  let envLanguage = 'en';
  if (window.location.pathname.includes('/fr/')) envLanguage = 'fr';
  if (window.location.pathname.includes('/es/')) envLanguage = 'es';

  const origin = window.location.origin;
  const pathname = window.location.pathname;
  const referrer = origin + pathname;

  return {
    ...getTrackingDefaultPayload(),
    ...pageCategories,
    envLanguage,
    envWork: window.location.hostname !== 'payfit.com' ? 'Dev' : 'Prod',
    title: document.title,
    referrer,
  };
};
